import { createContext, useContext, useMemo, useState, createElement } from "react";

const SeoContext = createContext(null);

export const SeoProvider = ({ children }) => {
  const [pageSeo, setPageSeo] = useState(null);

  const value = useMemo(
    () => ({ pageSeo, setPageSeo }),
    [pageSeo]
  );

  return createElement(SeoContext.Provider, { value }, children);
};

export const useSeo = () => {
  const context = useContext(SeoContext);

  if (!context) {
    throw new Error("useSeo must be used inside SeoProvider");
  }

  return context;
};
